__turbopack_context__.v({
  "bodyText": "VitaminAngels-module__gsxcyq__bodyText",
  "checkItem": "VitaminAngels-module__gsxcyq__checkItem",
  "checkItems": "VitaminAngels-module__gsxcyq__checkItems",
  "partnershipCallout": "VitaminAngels-module__gsxcyq__partnershipCallout",
  "sectionTitle": "VitaminAngels-module__gsxcyq__sectionTitle",
  "title": "VitaminAngels-module__gsxcyq__title",
  "vitaminAngelsWrapper": "VitaminAngels-module__gsxcyq__vitaminAngelsWrapper",
});
